import React, { memo } from 'react';

import { Box, Tooltip } from '@mui/material';
import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS';
import {
  LabelBorderStyle,
  LabelSize,
  LabelVariant,
} from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { getRecipientCopyLabel } from 'utils/documents';

import { DOCUMENT_LABEL_TOOLTIP_POPPER_PROPS } from '../../../../LoanApplicationDocuments.constants';
import {
  documentItemTagLabelStyles,
  documentItemTagWrapperStyles,
} from '../DocumentItemTag.styles';

import { DocumentRecipientCopyTagTestIds } from './DocumentRecipientCopyTag.testIds';
import { getRecipientCopyTagTooltip } from './DocumentRecipientCopyTag.utils';

const DocumentRecipientCopyTag = ({ documentId, signerName = null }) => {
  const tooltipTitle = getRecipientCopyTagTooltip(signerName);

  return (
    <Tooltip PopperProps={DOCUMENT_LABEL_TOOLTIP_POPPER_PROPS} title={tooltipTitle}>
      <Box
        aria-label={tooltipTitle}
        component="span"
        data-testid={DocumentRecipientCopyTagTestIds.getTagId(documentId)}
        role="img"
        sx={documentItemTagWrapperStyles}
      >
        <LabelCDS
          shrinkable
          withBorder
          borderStyle={LabelBorderStyle.SOLID}
          size={LabelSize.S}
          title={
            <Box component="span" sx={documentItemTagLabelStyles}>
              {getRecipientCopyLabel(signerName)}
            </Box>
          }
          variant={LabelVariant.BLUE}
        />
      </Box>
    </Tooltip>
  );
};

DocumentRecipientCopyTag.propTypes = {
  documentId: PropTypes.string.isRequired,
  signerName: PropTypes.string,
};

export default memo(DocumentRecipientCopyTag);
